import {
  APP_SIDEBAR_ITEMS,
  APP_ERROR,
  APP_GET_CURRENT_USER,
  APP_SIDEBAR_STATE,
  APP_GET_ALL_USERS,
} from "../typesAction";

const INITIAL_STATE = {
  errorMessage: null,
  inProgress: false,
  sidebarItems: [],
  currentUser: {},
  users: [],
  isSidebarOpened: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case APP_SIDEBAR_STATE:
      return { ...state, isSidebarOpened: action.payload };
    case APP_SIDEBAR_ITEMS:
      return { ...state, sidebarItems: action.payload, inProgress: false };
    case APP_GET_CURRENT_USER:
      return { ...state, currentUser: action.payload, inProgress: false };
    case APP_GET_ALL_USERS:
      return { ...state, users: action.payload, inProgress: false };
    case APP_ERROR:
      return {
        ...state,
        errorMessage: action.payload.response?.data,
        inProgress: false,
      };
    default:
      return state;
  }
}
